/* eslint-disable react/prop-types */
import React, {
  useRef, useCallback, useContext, useEffect, useState
} from 'react';
import {
  bool as boolType,
  string as stringType,
  number as numberType,
  shape, array, arrayOf
} from 'prop-types';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { dynamicRecsDataModel } from '../dataModel';
import {
  isLoading,
  getAppId,
  getLoyaltyMembershipInput,
  getDrecsImpressionID,
  getDrecsComponent,
  getDrecsimpressionType,
  getApiName,
  getTntSchema,
  getWrapperClass,
  getImpressionsNameValue,
  getCollectionTitle,
  getCollectionInitialIndexValue,
  useTabCountConfigValue,
  getAnalyticImpressionData,
  getSwatchImpressionData
} from '../utils/helpers';
import { ProductPodV7Carousel } from '../core/ProductPodV7Carousel';
import { Summary } from '../core/Summary';
import { MoreLikeThis } from '../core/MoreLikeThis';
import { CollectionCarousel } from '../core/CollectionCarousel';
import '../../styles/thd-recs-containers.scss';

let obj = null;
let isTNT = false;
if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recs.tnt', (data) => {
    isTNT = data?.eventName === 'tnt';
    obj = data?.output;
  });
}

const DynamicRecs = (props) => {
  const { storeId, storeZip: zipCode, isLocalized, membershipInformation } = useStore();
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const loadedStoreInfo = useRef({ storeId, zipCode });
  const batteryTabName = useRef([]);
  const {
    anchorId,
    anchorImage,
    schemaName,
    showLoading,
    serviceType,
    showColUpLevel,
    isBatteryCollection,
    isCollection,
    maxResults,
    requestKey,
    hideSwatches,
    hideATC,
    hideFavorites,
    checkMinimumProducts,
    parent,
    zoneName,
    zonePosition,
    itemIds,
    impressionData,
    miniumumProductCount,
    browseNValue,
    name,
    isCategoryTab,
    isIRG,
    recsContext,
    selectedItemProduct,
    isMoreLikeThis
  } = props;

  const tabCountConfigValue = useTabCountConfigValue(showColUpLevel);
  const mobile = channel === 'mobile';
  const {
    customerType: cType, mcvisID
  } = useThdCustomer() || {};

  const [newCategoryGuid, setNewCategoryGuid] = useState(anchorId);
  const [impressionCategoryName, setImpressionCategoryName] = useState('');
  const [impressionActiveIndex, setImpressionActiveIndex] = useState('');
  const tntSchema = getTntSchema(obj, schemaName);
  const initialBatteryTitle = useRef('');

  useEffect(() => {
    setNewCategoryGuid(anchorId);
  }, [anchorId]);

  const opts = {
    variables: {
      anchorId: newCategoryGuid,
      storeId,
      key: requestKey,
      zipCode,
      apiName: getApiName(isTNT, tntSchema, schemaName),
      skipInstallServices: true,
      dataSource: schemaName,
      loyaltyMembershipInput: getLoyaltyMembershipInput(membershipInformation),
      serviceType,
      cType,
      mcvisId: mcvisID,
      timeStamp: null,
      maxResults,
      appId: getAppId(channel, isConsumerApp),
      nvalue: browseNValue,
      recsContext: recsContext || null,
    },
    skip: !isLocalized,
    ssr: false
  };

  const {
    data, variables, loading, error, refetch
  } = useDataModel('recs', opts);

  useEffect(() => {
    if (itemIds && itemIds?.length > 0) {
      refetch();
    }
  }, [itemIds]);

  useEffect(() => {
    // this code executes only on the initial render or initial calls because
    // battery collection tab clicks calls has only 1 category data
    // For pipcollection  and IRG tabs click, we don't chnage loading value
    if (!loading && !error && data?.recs?.categories !== null) {
      if (isIRG && data?.recs?.categories.length > 1) {
        setImpressionCategoryName(getCollectionTitle(isIRG, isCategoryTab));
        setImpressionActiveIndex(getCollectionInitialIndexValue(isIRG, isCategoryTab));
      } else if (!mobile && data?.recs?.categories?.length >= tabCountConfigValue) {
        setImpressionCategoryName(getCollectionTitle(isIRG, isCategoryTab, isCollection));
        setImpressionActiveIndex(getCollectionInitialIndexValue(isIRG, isCategoryTab, isCollection));
      }
    }

    // Saving title of the battery collection container to handle impressions NAME value
    // for the battery collections fallback scenario
    if (!mobile && !loading && !error && isBatteryCollection && data?.recs?.metadata?.collectionName) {
      initialBatteryTitle.current = data?.recs?.metadata?.collectionName || '';
    }
  }, [loading]);

  if (data && !loading && isLocalized) {
    loadedStoreInfo.current = {
      storeId: variables.storeId,
      zipCode: variables.zipCode,
      mounted: true
    };
  }

  const setCategoryGuid = useCallback(
    (event, guid, categoryName, changeActiveIndex, index) => {
      event.preventDefault();
      batteryTabName.current = categoryName;
      changeActiveIndex(index);
      setNewCategoryGuid(anchorId + guid);
      setImpressionCategoryName(categoryName);
      setImpressionActiveIndex(index + 1);
    },
    []
  );

  const setVisualTabsCategoriesData = useCallback(
    (categoryName, index) => {
      setImpressionCategoryName(categoryName);
      setImpressionActiveIndex(index + 1);
    },
    []
  );

  const wrapperClasses = getWrapperClass(schemaName, showLoading, loading);

  if (checkMinimumProducts && data?.recs?.products?.length < miniumumProductCount) {
    return null;
  }

  if (anchorId === newCategoryGuid && (error || (data !== undefined && (!data || !data?.recs) && !loading))) {
    if ((schemaName === 'PLP_Search_In_Stock' || schemaName === 'PLP_Browse_In_Stock')) {
      return (
        <Typography variant="body-base" component="h4">
          <div className="sui-flex sui-justify-center sui-items-center">
            No similar items found
          </div>
        </Typography>
      );
    }
    return null;
  }

  const anchorIdForAnalytics = anchorId?.split(',')[0];

  let impressionName = '';

  if (!loading) {
    impressionName = getImpressionsNameValue(
      isCollection,
      showColUpLevel,
      isCategoryTab,
      isIRG,
    data?.recs?.metadata,
    data?.recs?.products,
    loading
    ) || initialBatteryTitle.current;
  }

  const swatchImpressionData = !hideSwatches ? getSwatchImpressionData(
    schemaName, impressionCategoryName, impressionActiveIndex, name) : null;

  return (
    <ImpressionProvider
      data={{
        id: getDrecsImpressionID(impressionData),
        component: getDrecsComponent(impressionData),
        name: impressionName,
        type: getDrecsimpressionType(impressionData),
        recType: schemaName || '',
        position: '',
        category: impressionCategoryName,
        categoryPosition: impressionActiveIndex,
        ...(name ? { sectionSlotID: name } : {}),
        ...((schemaName === 'trending_products') ? { zonePosition } : {}),
      }}
    >
      <div
        id={schemaName}
        className={wrapperClasses}
        data-type="container"
        data-component={`DynamicRecs-${schemaName}`}
      >
        <meta data-prop="name" content={schemaName} />
        { isMoreLikeThis && (
          <>
            <Summary
              id={anchorId}
              quantity={1}
              product={selectedItemProduct[0]}
            />
            <div className="sui-grid sui-grid-cols-2 sui-pr-2 sui-pl-2 sui-gap-2">
              <MoreLikeThis
                anchorId={anchorId}
                selectedItemProduct={selectedItemProduct}
                anchorImage={anchorImage}
                itemClass="fixed-item"
                scheme={schemaName}
                loading={isLoading(data, loading)}
                data={data?.recs}
                hideSwatches={hideSwatches}
                hideATC={hideATC}
                hideFavorites={hideFavorites}
                storeId={loadedStoreInfo.current.storeId}
                membershipInformation={membershipInformation}
                zipCode={loadedStoreInfo.current.zipCode}
                parent={parent || `recs-product-pod-carousel-${schemaName}`}
                zoneName={zoneName}
                zonePosition={zonePosition}
                podResults={data?.recs?.products?.length}
                analyticsAnchorProductSku={anchorIdForAnalytics}
                setVisualTabsCategoriesData={setVisualTabsCategoriesData}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
              />
            </div>
          </>
        )}
        {isCollection && (
          <CollectionCarousel
            anchorId={anchorId}
            anchorImage={anchorImage}
            itemClass="fixed-item"
            showColUpLevel={showColUpLevel}
            scheme={schemaName}
            isBatteryCollection={isBatteryCollection}
            tabClick={batteryTabName?.current}
            setCategoryGuid={setCategoryGuid}
            setVisualTabsCategoriesData={setVisualTabsCategoriesData}
            loading={isLoading(data, loading)}
            data={data?.recs}
            hideSwatches={hideSwatches}
            hideATC={hideATC}
            hideFavorites={hideFavorites}
            storeId={loadedStoreInfo.current.storeId}
            membershipInformation={membershipInformation}
            zipCode={loadedStoreInfo.current.zipCode}
            parent={`recs-product-pod-carousel-${schemaName}`}
            analyticsAnchorProductSku={anchorIdForAnalytics}
            tabCountConfigValue={tabCountConfigValue}
            analyticImpressionData={getAnalyticImpressionData('DynamicRecs', impressionName)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        )}
        {(!isCollection && !isMoreLikeThis) && (
          <ProductPodV7Carousel
            anchorId={anchorId}
            anchorImage={anchorImage}
            itemClass="fixed-item"
            scheme={schemaName}
            loading={isLoading(data, loading)}
            data={data?.recs}
            hideSwatches={hideSwatches}
            hideATC={hideATC}
            hideFavorites={hideFavorites}
            storeId={loadedStoreInfo.current.storeId}
            membershipInformation={membershipInformation}
            zipCode={loadedStoreInfo.current.zipCode}
            parent={parent || `recs-product-pod-carousel-${schemaName}`}
            zoneName={zoneName}
            zonePosition={zonePosition}
            podResults={data?.recs?.products?.length}
            analyticsAnchorProductSku={anchorIdForAnalytics}
            setVisualTabsCategoriesData={setVisualTabsCategoriesData}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        )}
      </div>
    </ImpressionProvider>

  );
};

const dataModel = dynamicRecsDataModel;
DynamicRecs.dataModel = dataModel;

DynamicRecs.displayName = 'DynamicRecsComponent';
const propTypes = {
  anchorId: stringType.isRequired,
  anchorImage: stringType,
  showColUpLevel: boolType,
  isBatteryCollection: boolType,
  isCollection: boolType,
  hideFavorites: boolType,
  maxItems: numberType,
  schemaName: stringType.isRequired,
  serviceType: stringType,
  showLoading: boolType,
  maxResults: stringType,
  browseNValue: stringType,
  requestKey: stringType,
  hideATC: boolType,
  checkMinimumProducts: boolType,
  zoneName: stringType,
  zonePosition: stringType,
  itemIds: stringType,
  impressionData: shape({
    id: stringType,
    component: stringType,
    type: stringType
  }),
  name: stringType,
  miniumumProductCount: numberType,
  isCategoryTab: boolType,
  isIRG: boolType,
  selectedItemProduct: arrayOf(shape({})),
  isMoreLikeThis: boolType
};

DynamicRecs.propTypes = propTypes;

const defaultProps = {
  anchorImage: null,
  showColUpLevel: false,
  isCollection: false,
  isBatteryCollection: false,
  hideFavorites: true,
  maxItems: 16,
  serviceType: null,
  maxResults: null,
  browseNValue: null,
  showLoading: true,
  hideATC: false,
  checkMinimumProducts: false,
  requestKey: 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee',
  zoneName: '',
  itemIds: '',
  selectedItemProduct: [],
  zonePosition: '',
  impressionData: {
    id: null,
    component: null,
    type: null
  },
  name: '',
  miniumumProductCount: 6,
  isCategoryTab: false,
  isIRG: false,
  isMoreLikeThis: false
};

DynamicRecs.defaultProps = defaultProps;

DynamicRecs.propTypes = propTypes;
DynamicRecs.defaultProps = defaultProps;
DynamicRecs.dataModel = dataModel;

export default DynamicRecs;
